import { forwardRef } from "react"
import { Flex, FlexProps } from "@mantine/core"
import "./index.css"

interface Props extends FlexProps {}

export const ScrollContainer = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref) => {
    return (
      <Flex
        ref={ref}
        className="custom-scroll-container"
        direction="column"
        mah="100%"
        w="100%"
        style={{ overflow: "auto" }}
        display="flex"
        {...props}
      >
        {children}
      </Flex>
    )
  }
)

ScrollContainer.displayName = "ScrollContainer"
